import React from 'react';
import { motion } from 'framer-motion';
export function TransitionBlock() {
  return <section className="py-14 px-6 bg-white" data-id="element-451">
      <div className="max-w-4xl mx-auto" data-id="element-452">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6 text-center" data-id="element-453">
          <p className="text-2xl md:text-3xl font-serif font-bold text-navy" data-id="element-454">
            Pero eso no es todo.
          </p>
          <p className="text-lg text-navy/80 leading-relaxed max-w-3xl mx-auto" data-id="element-455">
            Porque sé que leer un libro —aunque sea exactamente lo que
            necesitas— no siempre es suficiente cuando estás en medio del
            agotamiento.
          </p>
          <p className="text-lg text-navy/80 leading-relaxed max-w-3xl mx-auto" data-id="element-456">
            Necesitas algo que puedas usar hoy. Algo concreto. Sin rodeos. Sin
            teoría extra.
          </p>
          <p className="text-lg text-navy font-medium leading-relaxed max-w-3xl mx-auto" data-id="element-457">
            Por eso, cuando te llevas el libro hoy, recibes también estos 5
            bonos de implementación inmediata:
          </p>
        </motion.div>
      </div>
    </section>;
}